export const getUrsaIconColorVarName = () => `--sds--ursa-icons--text-color`;
